import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { routeName } from '../../../routes/routeName'
import StateComponents from '../../../components/state-component/StateComponents'
import ContainerButton from '../../../components/button/ContainerButton'
import { checkPermission, createOnKeyPress, handleTypingNumber, permission_config } from '../../../utils/app.utils'
import { PaymentChannelApi } from '../../../api/payment-channel/payment-channel.api'
import { BankAccountTypeOptions } from '../../cms/course-online/manage-payment-channel/enum/manage_payment'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice'
import { bankListArray } from '../../cms/course-online/manage-payment-channel/enum/manage_payment'
import { alertSuccess } from '../../../components/alert/swal'
import { RootState } from '../../../store/store'



type Props = {}

const ManagePaymentChannelsVisa = ({ }: Props) => {
    const dispatch = useDispatch();
    const profile = useSelector((state: RootState) => state.profile.profile) as any;
    const permission: any[] = profile?.permission || [];
    const checkPermit: permission_config = checkPermission(`MANAGE_PAYMENT_CHANNELS_VISA`, permission)

    const [formState, setFormState] = useState({
        account_name_eng: "",
        account_name_th: "",
        account_no: "",
        account_type: "",
        application_fee: "",
        bank_name_eng: "",
        bank_name_th: "",
        id_payment_channels: null,
        payment_channels_name: "",
        payment_channels_type: "",
        term_fee: ""
    })
    const [edit, setEdit] = useState<boolean>(false);
    const [select_bank, set_select_bank] = useState<any>(null);
    const handleGetDetail = async () => {
        dispatch(setLoading());
        await PaymentChannelApi.getPaymentChannelByType({ type_channel_payment: "VISA" }).then((res) => {
            if (res.status < 300) {
                const paymentChannel = res.data?.data?.paymentChannel;
                setFormState((prev) => ({ ...prev, ...paymentChannel }));
                if (paymentChannel?.bank_name_th) {
                    const data_value = bankListArray?.find((x) => x.name === paymentChannel?.bank_name_th) || null
                    set_select_bank(data_value);
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleChangeState = (field: string, value: string) => {
        setFormState((prev) => ({ ...prev, [field]: value }));
    }

    const handleSubmit = async () => {
        const formData = new FormData();
        // formData.append("file", "");
        formData.append("bank_name_th", select_bank?.name || "");
        formData.append("bank_name_eng", formState.bank_name_eng);
        formData.append("account_name_th", formState.account_name_th);
        formData.append("account_name_eng", formState.account_name_eng);
        formData.append("account_no", formState.account_no);
        formData.append("account_type", formState.account_type);
        if (formState.id_payment_channels) {
            dispatch(setLoading());
            await PaymentChannelApi.updatePaymentChannel(formState.id_payment_channels, formData).then((res) => {
                if (res.status < 300) {
                    setEdit(false);
                    alertSuccess("บันทึกข้อมูล", "บันทึกข้อมูล สำเร็จ")
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetDetail();
    }, [])

    return (
        <ContainerLayout
            title='จัดการช่องทางการชำระเงิน'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "ระบบคำร้อง",
                            name: "ระบบคำร้อง",
                            disabled_match: true,
                            pathName: ""
                        },
                        {
                            key: "จัดการช่องทางการชำระเงิน",
                            name: "จัดการช่องทางการชำระเงิน",
                            pathName: routeName.e_library.manage_payment_channels
                        },
                    ]}
                />
            }
            buttonContent={
                checkPermit?.isUpdate && <ContainerButton
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            key: "CANCEL",
                            label: "ยกเลิก",
                            hidden: !edit,
                            seq: 1,
                            type: "CANCEL",
                            buttonProps: {
                                onClick: () => {
                                    setEdit(false);
                                }
                            }
                        },
                        // {
                        //     key: "PUBLISH",
                        //     label: "เผยแพร่",
                        //     hidden: !edit,
                        //     seq: 2,
                        //     type: "PUBLISH",
                        //     buttonProps: {
                        //         onClick: () => { }
                        //     }
                        // },
                        {
                            key: "SAVE",
                            hidden: !edit,
                            label: "บันทึก",
                            seq: 3,
                            type: "SAVE",
                            buttonProps: {
                                onClick: () => handleSubmit()
                            }
                        },
                        {
                            key: "SAVE",
                            hidden: edit,
                            label: "แก้ไข",
                            seq: 4,
                            type: "EDIT",
                            buttonProps: {
                                onClick: () => {
                                    setEdit(true);
                                }
                            }
                        },
                    ]}
                />
            }
            content={
                <div className='w-full'>
                    <section className='grid grid-cols-12 gap-8'>
                        <article className='col-span-12 md:col-span-4'>
                            <StateComponents
                                disabledAllField={!edit}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op) => op?.fullname,
                                            labelId: "bank",
                                            heading: "ธนาคาร",
                                            placeholder: "ระบุ",
                                            onChange: (_, val) => set_select_bank(val),
                                            options: bankListArray || [],
                                            value: select_bank
                                        }
                                    }
                                ]}
                            />
                            {select_bank && (
                                <div className='w-full h-fit flex justify-center bg-[#DDE1EB] mt-4 rounded-xl items-center px-4 py-10'>
                                    <img src={select_bank?.icon} alt={select_bank?.symbol} />
                                </div>
                            )}
                        </article>
                        <article className='col-span-12 md:col-span-8'>
                            <StateComponents
                                disabledAllField={!edit}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            onChange: (e) => handleChangeState('account_name_th', e.target.value),
                                            value: formState.account_name_th,
                                            onkeypress: createOnKeyPress('thai'),
                                            heading: "ชื่อบัญชี (ภาษาไทย)",
                                            placeholder: "ระบุ",
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            onChange: (e) => handleChangeState('account_name_eng', e.target.value),
                                            value: formState.account_name_eng,
                                            onkeypress: createOnKeyPress('english'),
                                            heading: "ชื่อบัญชี (ภาษาอังกฤษ)",
                                            placeholder: "ระบุ",
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            // mode: ",
                                            value: formState.account_no,
                                            onChange: (e) => handleChangeState('account_no', e.target.value),
                                            heading: "เลขที่บัญชี",
                                            placeholder: "ระบุ",
                                            onkeypress: (even: any) => {
                                                if (!/[0-9.-]/.test(even.key)) {
                                                    even.preventDefault();
                                                }
                                            },
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op) => op?.label,
                                            labelId: "d",
                                            heading: "ประเภทบัญชี",
                                            placeholder: "ระบุ",
                                            onChange: (_, e) => handleChangeState('account_type', e?.value),
                                            options: BankAccountTypeOptions || [],
                                            value: BankAccountTypeOptions?.find((x) => x?.value === formState.account_type) || null
                                        }
                                    }
                                ]}
                            />
                        </article>
                    </section>
                </div>
            }
        />
    )
}

export default ManagePaymentChannelsVisa